import React from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { useReportError } from './ReportErrorContext';

export interface PanelBoundaryProps {
  children: React.ReactNode;
  panelName?: string;
}

export function PanelBoundary({ children, panelName }: PanelBoundaryProps): React.ReactElement {
  const reportError = useReportError();

  return (
    <ErrorBoundary
      fallback={(error, reset) => (
        <div className="error-boundary" role="alert">
          <div className="error-boundary__content">
            <h2 className="error-boundary__title">This section couldn't load</h2>
            <p className="error-boundary__message">
              {panelName
                ? `The ${panelName} hit an error. Your data is safe.`
                : 'An unexpected error occurred. Your data has not been lost.'}
            </p>
            <div className="error-boundary__actions">
              <button
                className="btn btn--primary btn--md"
                onClick={reset}
                type="button"
              >
                Try again
              </button>
              <button
                className="btn btn--secondary btn--md"
                onClick={() => reportError(error.message)}
                type="button"
              >
                Report this error
              </button>
            </div>
          </div>
        </div>
      )}
    >
      {children}
    </ErrorBoundary>
  );
}
